import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;

    div.Container__stats {
        width: 100%;
        display: flex;
        gap: 10px;

        div.Container__stats__percent {
            width: calc(100% - 515px);
            display: flex;
            align-items: center;

            div.Container__stats__percent__bar {
                margin-top: -8px;
                width: 100%;
                display: flex;
                align-items: center;
                gap: 5px;
                font-size: 11px;
                font-weight: 600;
                color: var(--text-color);

                div.Container__stats__percent__bar__track {
                    width: 100%;
                    height: 7px;
                    border-radius: 5px;
                    background: #FAFAFA;
                    overflow: hidden;

                    div.Container__stats__percent__bar__track__progress {
                        width: 0%;
                        height: 100%;
                        border-radius: 5px;
                        background: linear-gradient(to right, #5da57d, #7ebd61);

                        :is([data-overlap = true]) {
                            background: linear-gradient(to right, #5da57d, #7ebd61, #7ebd61, #ffd700);
                        }
                        :is([data-overlap_150 = true]) {
                            background: linear-gradient(to right, #5da57d, #7ebd61, #7ebd61, #ffd700, #ffd700);
                        }
                        :is([data-overlap_200 = true]) {
                            background: linear-gradient(to right, #5da57d, #7ebd61, #7ebd61, #ffd700, #ffd700, #f14f46);
                        }
                        :is([data-overlap_250 = true]) {
                            background: linear-gradient(to right, #5da57d, #7ebd61, #7ebd61, #ffd700, #ffd700, #f14f46, #f14f46);
                        }
                        :is([data-overlap_300 = true]) {
                            background: linear-gradient(to right, #5da57d, #7ebd61, #ffd700, #ffd700, #f14f46, #f14f46);
                        }
                    }
                }
            }
        }
    }
`;

export const CardInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    font-weight: 500;
    color: var(--text-color-light);
    font-size: 12px;
    line-height: 1.3;
    padding: 7px;
    border-radius: 7px;

    :is([data-color = 'gray']) {
        background: rgb(240,240,240,0.8);
    }
    :is([data-color = 'blue']) {
        background: var(--atv-negativo-light);
        color: var(--atv-negativo);
        span {
            color: var(--atv-negativo);
        }
    }
    :is([data-color = 'purple']) {
        background: #fbf2ff;
        color: #541dad;
        span {
        color: #541dad;
        }
    }
    :is([data-color = 'green']) {
        background: var(--atv-positivo-light);
        color: var(--atv-positivo);
        span {
            color: var(--atv-positivo);
        }
    }

    span {
        color: var(--text-color);
        margin: 0 !important;
        padding: 0 !important;
        font-weight: 700;
        font-size: 15px;
    }
`;